import React, { useState, useEffect, useRef } from "react";
import "./lottery-bet.css";
import "./lottery-bet-modern.css";
import Barcode from "react-jsbarcode";
import { socket } from "../../io";
import Modal from "react-bootstrap/Modal";
import { headers, url } from "../../utils/const";
import imgLogo from "../../assets/logo-reina.png";
import { ToPrinter } from "../../utils/print-service";
import { formatLotteryBets, mergeLotteryBets } from "../../utils/lottery-bets";
import PosNavigation from "./pos-navigation";
let print = undefined;
const createIdempotencyKey = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return "reina-" + Date.now() + "-" + Math.random().toString(36).slice(2);
};
const readApiResponse = async (response) => {
  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json")
    ? await response.json()
    : await response.text();
  if (!response.ok) {
    const message = typeof data === "string" ? data : data?.message || data?.msg;
    throw new Error(message || `Error ${response.status}`);
  }
  return data;
};

function LoteryBet() {
  const [time, setTime] = useState("");
  const [salesState, setSalesState] = useState("unknown");
  const [inputValue, setInputValue] = useState("");
  const [firstEnter, setFirstEnter] = useState(false);
  const [textareaValue, setTextareaValue] = useState("");
  const [currentBet, setCurrentBet] = useState([]);
  const [error, setError] = useState("");
  const [PrintSt, setPrintSt] = useState();
  const [show, setShow] = useState("");
  const [inTeclado, setInTeclado] = useState("");
  const [winner, setWinner] = useState("");
  const [showTicket, setShowTicket] = useState(false);
  const textareaRef = useRef(null);
  const salePendingRef = useRef(false);
  const actionPendingRef = useRef(false);
  const paymentConfirmationRef = useRef(null);
  /** Datos de la Carrera actual para cual sera la apuesta  IMP*/
  useEffect(() => {
    if (!localStorage.getItem("user")) return (window.location.href = "/");
    const handleScream = (data) => {
      if (Object.prototype.hasOwnProperty.call(data || {}, "time") && Number.isFinite(Number(data.time))) {
        const seconds = Number(data.time);
        setTime(seconds);
        setSalesState(seconds > 10 ? "open" : "closed");
        return;
      }
      if (Number(data?.scream) === 2 || Number(data?.scream) === 4) {
        setTime("");
        setSalesState("closed");
      }
    };
    const requestSalesStatus = () => socket.emit("lottery-sales-status");
    const handleDisconnect = () => {
      setTime("");
      setSalesState("unknown");
    };
    socket.on("scream", handleScream);
    socket.on("get", handleScream);
    socket.on("connect", requestSalesStatus);
    socket.on("disconnect", handleDisconnect);
    requestSalesStatus();
    return () => {
      socket.off("scream", handleScream);
      socket.off("get", handleScream);
      socket.off("connect", requestSalesStatus);
      socket.off("disconnect", handleDisconnect);
    };
  }, []);
  useEffect(() => {
    if (!PrintSt || !PrintSt.num) return undefined;
    if (localStorage.getItem("level") !== "4") {
      window.location.href = "/";
      return undefined;
    }

    let active = true;
    print = PrintSt;
    ToPrinter(PrintSt).then((result) => {
      if (!active) return;
      if (result.printed) {
        setWinner(result.protocol === "legacy"
          ? `Ticket ${PrintSt.num} enviado al servidor de impresión.`
          : `Ticket ${PrintSt.num} impreso por el servicio local.`);
      } else {
        const detail = result.detail || result.reason || "servicio local no disponible";
        setWinner(`Ticket ${PrintSt.num} registrado, pero no impreso. Verifique la impresora del puerto 5000. ${detail}`);
      }
      setPrintSt(undefined);
    });

    return () => { active = false; };
  }, [PrintSt]);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [textareaValue]);
  useEffect(() => {
    setTextareaValue(formatLotteryBets(currentBet));
  }, [currentBet]);
  const handleInputChange = (e) => {
    const { value } = e.target;
    const lastChar = value.slice(-1);
    if (/^\d*$/.test(lastChar) || (firstEnter && lastChar === "$")) {
      if (paymentConfirmationRef.current?.ticket !== value.replace("$", ""))
        paymentConfirmationRef.current = null;
      setInputValue(value);
    }
  };
  if (!localStorage.getItem("user")) {
    return (window.location.href = "/");
  }
  const salesOpen = salesState !== "closed";
  const ticketNumber = () => String(inputValue || "").replace(/\$/g, "").trim();
  const clearSelection = () => {
    setInputValue("");
    setFirstEnter(false);
    setTextareaValue("");
    setCurrentBet([]);
    setError("");
  };
  const handleKeyDown = (e) => {
    if (e.key !== "Enter") return;
    if (inputValue === "") {
      if (!salesOpen) {
        setError("Las ventas nuevas están pausadas mientras se procesa el sorteo.");
        return;
      }
      if (currentBet.length === 0) {
        setError("Agregue al menos una jugada antes de registrar el ticket.");
        return;
      }
      if (salePendingRef.current) return;
      salePendingRef.current = true;
      fetch(`${url}/lotery-bet`, {
        method: "POST",
        headers: { ...headers, "x-idempotency-key": createIdempotencyKey() },
        body: JSON.stringify([currentBet]),
      })
        .then(async (res) => {
          const data = await res.json();
          if (!res.ok) {
            const message = typeof data === "string" ? data : data?.message;
            throw new Error(message || "No se pudo registrar la jugada");
          }
          if (localStorage.getItem("level") === "4" && (!data || !Array.isArray(data.betted))) {
            throw new Error("El servidor no devolvió los datos del ticket.");
          }
          return data;
        })
        .then((data) => {
          ToPrint(data);
          setError("");
          if (Array.isArray(data?.betted)) setCurrentBet([]);
        })
        .catch((cause) => {
          const message = typeof cause?.message === "string" ? cause.message : "No se pudo registrar la jugada";
          setWinner(message);
          setError(message);
        })
        .finally(() => {
          salePendingRef.current = false;
        });
      return;
    }
    if (!salesOpen) {
      setError("Las ventas nuevas están pausadas mientras se procesa el sorteo.");
      return;
    }
    if (firstEnter === false) {
      setInputValue((prev) => `${prev}$`);
      setFirstEnter(true);
    } else {
      const [firstPart, secondPart] = inputValue.split("$");
      if (firstPart.length === 2 || firstPart.length === 4 || firstPart.length === 6) {
        const spacedFirstPart = [
          ...new Set(
            firstPart
              .match(/.{1,2}/g)
              .join(" ")
              .split(" ")
          ),
        ].join(" ");
        const amountValue = secondPart.trim() === "" ? 10 : parseFloat(secondPart);
        const type = spacedFirstPart.length == 8 ? "T" : spacedFirstPart.length == 5 ? "P" : "Q";
        setError("");
        setCurrentBet((bets) => mergeLotteryBets(bets, [{ amount: amountValue, type, bet: spacedFirstPart }]));
        setInputValue("");
        setFirstEnter(false);
      } else {
        setError("La longitud del número debe ser 2, 4 o 6.");
      }
    }
  };
  /**IMP */
  /**Eliminar */
  const requestTicketDeletion = () => {
    const ticket = ticketNumber();
    if (!/^\d+$/.test(ticket)) {
      setError("Digite un número de ticket válido para anularlo.");
      return;
    }
    setInTeclado(ticket);
    setShow(true);
  };

  /**Eliminar Ticket */
  const EliminarTicket = () => {
    if (actionPendingRef.current) return;
    const ticket = ticketNumber() || inTeclado;
    if (!/^\d+$/.test(ticket)) {
      setError("Digite un número de ticket válido para anularlo.");
      return;
    }
    actionPendingRef.current = true;
    fetch(`${url}/lotery-bet/pay`, {
      method: "post",
      headers: headers,
      body: JSON.stringify({ ticket, action: "delete" }),
    })
      .then(readApiResponse)
      .then((data) => {
        const message = typeof data === "string" ? data : data?.msg || "Ticket anulado";
        setWinner(message);
        setError("");
        if (showTicket === true) {
          setTimeout(() => setShowTicket(false), 150);
          Clear();
        }
        setInputValue("");
        setFirstEnter(false);
        setInTeclado("");
        paymentConfirmationRef.current = null;
        setShow(false);
      })
      .catch((cause) => setError(cause?.message || "No se pudo anular el ticket"))
      .finally(() => {
        actionPendingRef.current = false;
      });
  };
  /**Realizar apuesta */
  const ToPrint = (data) => {
    console.log(data);
    if (localStorage.getItem("level") !== "4") return (window.location.href = "/");
    //  if (active === true) {
    if (typeof data === "string" || !Array.isArray(data?.betted)) {
      const message = typeof data === "string"
        ? data
        : typeof data?.message === "string"
          ? data.message
          : "Respuesta inválida del servidor al generar el ticket.";
      setWinner(message);
      return;
    }
    setWinner("");
    print = data;
    setPrintSt(data);
    setInputValue("");
    setTextareaValue("");
    setFirstEnter(false);

    // }
  };
  /**Limpia el input del ticket */
  const Clear = () => {
    setInTeclado("");
  };
  /**Enter Para Pago */
  const EnterPay = (action) => {
    if (actionPendingRef.current) return;
    const ticket = ticketNumber();
    if (!/^\d+$/.test(ticket)) {
      setError("Digite un número de ticket válido.");
      return;
    }
    if (action === "repeat" && !salesOpen) {
      setError("No se puede repetir un ticket mientras las ventas están pausadas.");
      return;
    }
    actionPendingRef.current = true;
    const confirmation = paymentConfirmationRef.current?.ticket === ticket
      ? paymentConfirmationRef.current.token
      : undefined;
    const requestHeaders = action === "repeat"
      ? { ...headers, "x-idempotency-key": createIdempotencyKey() }
      : headers;
    setShowTicket(false);
    fetch(`${url}/lotery-bet/pay`, {
      method: "post",
      headers: requestHeaders,
      body: JSON.stringify({
        ticket,
        action,
        ...(action === "pay" && confirmation
          ? { confirmationToken: confirmation }
          : {}),
      }),
    })
      .then(readApiResponse)
      .then((data) => {
        if (action === "repeat") {
          if (!data?.ticket) throw new Error(data?.message || "El servidor no devolvió el ticket repetido.");
          paymentConfirmationRef.current = null;
          print = data.ticket;
          setPrintSt(data.ticket);
          setWinner(data.msg || "Ticket repetido");
          setError("");
          Clear();
          setInputValue("");
          setFirstEnter(false);
          return;
        }
        if (data?.confirmationToken) {
          paymentConfirmationRef.current = {
            ticket,
            token: data.confirmationToken,
          };
          setWinner(`Monto a pagar: RD$ ${Number(data.amountToPay || 0).toLocaleString("en-EN")}. Pulse Pagar nuevamente para confirmar.`);
          setError("");
        } else if (data?.ticket && data?.msg) {
          paymentConfirmationRef.current = null;
          print = data.ticket;
          setPrintSt(data.ticket);
          setWinner(data.msg);
          setError("");
          Clear();
          setInputValue("");
          setFirstEnter(false);
        } else if (typeof data === "string") {
          paymentConfirmationRef.current = null;
          setWinner(data);
          setError("");
        } else {
          throw new Error(data?.message || data?.msg || "Respuesta inválida del servidor");
        }
      })
      .catch((cause) => setError(cause?.message || "No se pudo completar la operación"))
      .finally(() => {
        actionPendingRef.current = false;
      });
  };
  const handleTextareaChange = (e) => {
    setTextareaValue(e.target.value);
  };

  return (
      <div className="container-fluid vh-100 vw-100 queen-pos-page">
        <div className="yPrint print text-center">
          <div className="p-0 m-0">
            {print && print.winner ? (
              ""
            ) : print && print.codeRun ? (
              <div className="p-0 m-0">
                <div className="col-12 justify-content-center p-0 m-0">
                  <div className="col-12">
                    <Barcode
                      value={print ? print.num : "000000"}
                      options={{
                        format: "code128",
                        height: 25,
                        displayValue: false,
                      }}
                      renderer="svg"
                    />
                  </div>
                </div>
                <h6>{print ? print.pv : ""}</h6>
                <div className="col-12 row justify-content-center p-0 m-0">
                  <div className="col fs-6 p-0 m-0">Sorteo: {print ? `${print.codeRun}` : ""}</div>
                  <div className="col fs-6 p-0 m-0">Ticket No.: {print ? print.num : ""}</div>
                </div>
                <h6>Fecha: {print ? `${new Date(print.date).toLocaleDateString("es-ES")} ${new Date(print.date).getHours().toString().padStart(2, "0")}:${new Date(print.date).getMinutes().toString().padStart(2, "0")}:${new Date(print.date).getSeconds().toString().padStart(2, "0")}` : ""}</h6>
              </div>
            ) : (
              <div className="p-0 m-0">
                <div className="col-12 justify-content-center p-0 m-0">
                  <div className="col-12">
                    <Barcode
                      value={print ? print.num : "000000"}
                      options={{
                        format: "code128",
                        height: 25,
                        displayValue: false,
                      }}
                      renderer="svg"
                    />
                  </div>
                </div>
                <h6>{new Date().getHours()}</h6>
                <div className="col-12 row justify-content-center p-0 m-0">
                  <div className="col fs-6 p-0 m-0">Sorteo: {print ? `${print.codeRun}` : ""}</div>
                  <div className="col fs-6 p-0 m-0">Ticket No.: {print ? print.num : ""}</div>
                </div>
                <h6>Fecha: {new Date().toLocaleDateString("es-ES")}</h6>
              </div>
            )}
            {print && print.winner ? (
              <div className="text-center">
                <h3>Monto Ganador:</h3>
                <div className=" col-12 divLogoPrint align-midle mt-0 pt-0">
                  <img className="imgLogoPrint" src={imgLogo} alt="La Reina" />
                </div>
                <h3>{parseInt(print.winner.amountToPay).toLocaleString("en-EN", { maximumFractionDigits: 0 })}</h3>
                <div>.</div>
              </div>
            ) : (
              <div>
                <div className=" col-12 divLogoPrint align-midle">
                  <img className="imgLogoPrint " src={imgLogo} alt="La Reina" />
                </div>
                <table className="table table-sm col-12 p-0 m-0 lh-1">
                  <thead>
                    <tr>
                      <th className="ml-3 pl-3 text-start fs-5">Jugadas</th>
                      <th className="ml-3 pl-3 fs-5">Apostado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {print
                      ? print.betted.map((z) => (
                          <tr key={z.code} className="">
                            <td className="ml-3 pl-3 text-start fs-5">{z.numbers?.length == 1 ? `Q ${z.numbers[0]}` : z.numbers?.length == 2 ? `P ${z.numbers.join(" ")}` : z.numbers?.length == 3 ? `T ${z.numbers.join(" ")}` : "No Valida"}</td>
                            <td className="fs-5">
                              {parseInt(z.betted).toLocaleString("en-EN", {
                                maximumFractionDigits: 1,
                              })}
                            </td>
                          </tr>
                        ))
                      : ""}
                  </tbody>
                </table>
                <h2>Total Apostado: {print ? print.amount : ""}</h2>
                <div>.</div>
              </div>
            )}
          </div>
        </div>

        <div className="noPrint">
          <Modal show={show} onHide={() => setShow(false)} size="sm" className="" centered>
            <Modal.Header closeButton></Modal.Header>
            <form>
              <Modal.Body>
                <h3>Desea Anular Tickey {inTeclado}?</h3>
              </Modal.Body>
              <Modal.Footer className="col-12 row justify-content-between">
                <div className="col">
                  {" "}
                  <button type="button" className="btn btn-warning form-control" onClick={() => setShow(false)}>
                    Cerrar
                  </button>
                </div>
                <div className="col">
                  {" "}
                  <button type="button" onClick={EliminarTicket} className="btn btn-danger form-control">
                    {" "}
                    Aceptar{" "}
                  </button>
                </div>
              </Modal.Footer>
            </form>
          </Modal>
          <Modal show={showTicket} onHide={() => setShowTicket(false)} size="" className="noPrint" centered>
            <Modal.Header>
              <button className="btn btn-close" onClick={() => setShowTicket(false)}></button>
            </Modal.Header>
            <form>
              <Modal.Body className="col-12 text-center fs-1">Ticket: {inTeclado}</Modal.Body>
              <Modal.Footer>
                <div className="col-12 row">
                  <div className="col">
                    <input className="btn btn-primary form-control fs-3" type="button" onClick={() => EnterPay("pay")} value={"Pagar"} />
                  </div>

                  <div className="col">
                    <input type="button" className="form-control btn btn-danger fs-3" onClick={requestTicketDeletion} value="Eliminar" />
                  </div>
                  <div className="col">
                    <button type="button" className="form-control btn btn-warning fs-3" onClick={() => EnterPay("repeat")}>
                      Repetir
                    </button>
                  </div>
                </div>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
        <div className="container-fluid row p-3 justify-content-start noPrint queen-pos">
          <PosNavigation active="bet" />
          <div className="col-12 p-0 m-0 row justify-content-end form-group queen-pos-content">
            <div className="col-12 p-0 m-0 row p-3 justify-content-start queen-pos-status">
              <div className="row col-12 justify-content-between queen-pos-status-line">
                <div className="col"></div>
                <div className="col"></div>
                <div className="col fs-2 text-end text-white queen-pos-timer">{salesState === "closed" ? "Sorteo en curso" : time !== "" ? `Próximo sorteo en: ${time} seg.` : "Sincronizando sorteo..."}</div>
              </div>
              <div className="col-4 p-0 m-0 form-group"> </div>
            </div>

            <div className="col-12 row justify-content-center queen-pos-workspace">
              <div className="col-6 p-0 m-0 queen-pos-entry-card">
                <div className={error ? "queen-pos-message has-error" : "queen-pos-message"} role="status">{error || winner || (salesState === "closed" ? "Sorteo en curso: las ventas nuevas están pausadas; las demás funciones siguen disponibles." : salesState === "unknown" ? "Punto de venta disponible; sincronizando el reloj del sorteo." : "Punto de venta listo para registrar jugadas.")}</div>
                <input type="text" className="form-control queen-pos-input" value={inputValue} onChange={handleInputChange} onKeyDown={handleKeyDown} placeholder="Números → Enter → monto (vacío = RD$10) → Enter" aria-label="Jugadas o número de ticket" autoComplete="off" />
                <p className="queen-pos-hint">Para jugar: escribe una selección de 2, 4 o 6 dígitos, pulsa Enter y luego escribe el monto. Si vuelves a pulsar Enter sin monto, se registra <strong>RD$10</strong>. Para pagar, eliminar o repetir un ticket, escribe su número en este mismo campo.</p>
                <div className="col-12 row mt-3 pt-3 queen-pos-actions">
                  <div className="col">
                    <input className="btn btn-primary form-control fs-2" type="button" onClick={() => EnterPay("pay")} value={"Pagar"} />
                  </div>

                  <div className="col">
                    <input type="button" className="form-control btn btn-danger fs-2" onClick={requestTicketDeletion} value="Eliminar" />
                  </div>
                  <div className="col">
                    <button type="button" className="form-control btn btn-success border-white fs-2" onClick={() => EnterPay("repeat")}>
                      Repetir
                    </button>
                  </div>
                </div>
              </div>
            <div className="col-12"></div>
              <div className="col-6 p-0 m-0 pt-3 mt-3 queen-pos-ticket-card">
                <textarea className="form-control p-0 m-0 pt-3 mt-1 fs-3 text-center queen-pos-ticket-lines" ref={textareaRef} value={textareaValue} onChange={handleTextareaChange} placeholder="Las jugadas agregadas aparecerán aquí." aria-label="Jugadas actuales del ticket" style={{ width: "100%", resize: "none" }} />
              </div>
              <div className="col-12"></div>
              <div className="col-6 justify-content-end queen-pos-total-card">
                <span className="text-white fs-3 text-end">Monto Apostado: </span><span className="fs-1 text-warning">${currentBet.map((item) => item.amount).reduce((acum, current) => acum + current, 0)}</span>
              </div>
              <div className="col-12"></div>
             {/* <div className="col-6 pr-3 mr-3 row">
                <button className="form-control btn btn-danger fs-2" style={{ marginTop: "10px" }} onClick={()=>Mix('pale')}>
                  COMBINAR PALE
                </button>
              </div>*/}
              <div className="col-6 pr-3 mr-3 row queen-pos-cancel-card">
                <button className="form-control btn btn-danger fs-2" style={{ marginTop: "10px" }} onClick={clearSelection}>
                  LIMPIAR SELECCIÓN / CANCELAR
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}
export default LoteryBet;
